export default __webpack_public_path__ + "static/media/facebook.daf536c1.svg";